module.exports = __webpack_public_path__ + "img/vertical_2_1_8004.b1a9e90c.png";